// extracted by mini-css-extract-plugin
module.exports = {"tabs__header":"Tabs_tabs__header__3wusF","wrapper_title":"Tabs_wrapper_title__9T6uK","tabs__content":"Tabs_tabs__content__1dvrP"};